<template>
    <div
        v-if="!element.isNotSupport"
        class="action-machine d-flex flex-row no-select"
        :class="{
            'action-machine--demo': element.isDemo,
            'action-machine--disabled': element.isDemoMachineDisabled,
        }"
    >
        <!-- Is creating... -->
        <div
            v-if="element.isCreating"
            class="flex-fill d-flex flex-column justify-content-stretch justify-content-md-end align-items-md-end creating mr-3"
        >
            <div
                style="color: darkorange; font-weight: 500"
                class="font-size-75"
            >
                <span>Creating...</span>
                <span v-if="element.cloneProgress && element.cloneProgress > 0">
                    {{ element.cloneProgress }}%
                </span>
            </div>
            <v-progress-linear
                class="mt-2 progress-linear"
                :indeterminate="true"
                color="light-blue"
                height="10"
                :value="0"
            ></v-progress-linear>
            <div class="mt-1 mb-3 progress-text font-size-85" >
                This may take up to 5 minutes
            </div>
        </div>

        <!-- Is restarting... -->
        <div
            v-if="element.status === $machineStatus.RESTARTING"
            class="flex-fill d-flex flex-column justify-content-stretch justify-content-md-end align-items-md-end creating mr-3"
        >
            <div
                style="color: darkorange; font-weight: 500"
                class="font-size-75"
            >
                Restarting...
            </div>
            <v-progress-linear
                class="mt-2 progress-linear"
                :indeterminate="true"
                color="light-blue"
                height="10"
                :value="0"
            ></v-progress-linear>
            <div class="mt-1 mb-3 progress-text font-size-85" >
                Process takes 5 - 10 minutes
            </div>
        </div>

        <!-- Is reset... -->
        <div
            v-if="element.status === $machineStatus.RESET"
            class="flex-fill d-flex flex-column justify-content-stretch justify-content-md-end align-items-md-end creating mr-3"
        >
            <div
                style="color: darkorange; font-weight: 500"
                class="font-size-75"
            >
                Reseting...
            </div>
            <v-progress-linear
                class="mt-2 progress-linear"
                :indeterminate="true"
                color="light-blue"
                height="10"
                :value="0"
            ></v-progress-linear>
            <div class="mt-1 mb-3 progress-text font-size-85"
            >
                Process takes 5 - 10 minutes
            </div>
        </div>

        <!-- Is starting... -->
        <div
            v-if="element.isStarting"
            class="flex-fill d-flex flex-column justify-content-stretch justify-content-md-end align-items-md-end starting mr-3"
        >
            <div style="color: black; font-weight: 500" class="font-size-75">
                <span> {{ element.bootStepText }}... </span>
                <span v-if="element.bootStep === 2" style="color: #757575"
                    >( {{ element.loadingProgress }}% )</span
                >
            </div>
            <v-progress-linear
                class="mt-2 progress-linear"
                :indeterminate="element.bootStep === 2 ? false : true"
                color="light-blue"
                height="10"
                :value="element.bootStep === 2 ? element.loadingProgress : 0"
            ></v-progress-linear>
            <div class="mt-1 mb-3 progress-text font-size-85" >
                {{ bootStepDescription[element.bootStep] }}
            </div>
        </div>

        <!-- Is saving... -->
        <div
            v-if="element.isSaving"
            disabled="true"
            class="d-flex flex-column align-items-center waiting-system"
        >
            <IconSaving />
            <span
                style="color: #fb8c00; font-weight: 500"
                class="font-size-75 mt-2"
            >
                <span>Saving...</span>
                <span v-if="element.loadingProgress > 0">
                    {{ element.loadingProgress }}%
                </span>
            </span>
        </div>

        <!-- Processing... -->
        <div
            v-if=" (element.status === $machineStatus.PROCESSING && !(element.isSnsCreating || element.isSnsRestoring)) "
            disabled="true"
            class="d-flex flex-column align-items-center waiting-system"
        >
            <IconProcessing />
            <span
                style="color: #fb8c00; font-weight: 500"
                class="font-size-75 mt-2"
                >Processing</span
            >
        </div>

        <!-- Fixed rental renewal -->
        <div
            v-if="element.showRenewalFixedRental"
            @click="action($action.OPEN_POPUP_FIXED_RENTAL_RENEWAL_MACHINE)"
            class="d-flex flex-column align-items-center shutdown-for-clone"
        >
            <IconExtend />
            <span class="font-size-75 mt-2">Renewal</span>
        </div>

        <!-- Boot machine -->
        <div
            v-if="
                element.canBooting 
                && !(element.isSnsCreating || element.isSnsRestoring)
                && !element.isDemoMachineDisabled
            "
            @click="action($action.OPEN_POPUP_BOOT_MACHINE)"
            class="d-flex flex-column align-items-center boot-system"
        >
            <IconBoot />
            <span class="font-size-75 mt-2 text-nowrap">Boot ready</span>
        </div>

        <!-- Creating or Restoring -->
        <div
            v-if=" ((element.canBooting || element.status === $machineStatus.PROCESSING || element.status === 1) && (element.isSnsCreating || element.isSnsRestoring)) "
            class="flex-fill d-flex flex-column justify-content-stretch justify-content-md-end align-items-md-end starting"
        >
            <div
                style="color: darkorange; font-weight: 500"
                class="font-size-75"
            >
                <span>{{
                    element.isSnsCreating
                        ? "Creating snapshot..."
                        : "Restoring snapshot..."
                }}</span>
            </div>
            <v-progress-linear
                class="mt-2 progress-linear"
                :indeterminate="element.snsProgress > 0 ? false : true"
                color="light-blue"
                height="10"
                :value="element.snsProgress"
            ></v-progress-linear>
            <div class="mt-1 mb-3 progress-text font-size-85" >
                This may take up a few minutes
            </div>
        </div>

        <!-- Report Issues -->
        <div
            v-if="(element.canReportIssues && element.status === 2)"
            @click="action($action.OPEN_POPUP_EXTRA_SERVICE_REPORT_ISSUES)"
            style="text-decoration: none"
            class="d-flex flex-column align-items-center report-issues"
        >
            <i class="el-icon-warning-outline" style="font-size: 2.3rem"></i>
            <span class="font-size-75 mt-2 text-nowrap">Report issues</span>
        </div>

        <!-- Timer -->
        <div
            v-if="element.canScheduler"
            @click="action($action.OPEN_POPUP_SCHEDULER_MACHINE)"
            style="text-decoration: none"
            class="d-flex flex-column align-items-center timer"
        >
            <IconTimer />
            <span class="font-size-75 mt-2">Scheduler</span>
        </div>

        <!-- Shutdown -->
        <div
            v-if="element.canShutdown"
            @click="action($action.OPEN_POPUP_SHUTDOWN_MACHINE)"
            class="d-flex flex-column align-items-center shutdown"
        >
            <IconShutdown />
            <span class="font-size-75 mt-2">Shutdown</span>
        </div>

        <!-- Download remote desktop -->
        <div
            v-if="element.canConnect"
            @click="action($action.OPEN_POPUP_DOWNLOAD_REMOTE_DESKTOP)"
            style="text-decoration: none"
            target="_blank"
            class="d-flex flex-column align-items-center connection"
        >
            <IconConnect />
            <span class="font-size-75 mt-2">Connect</span>
        </div>

        <!-- Error -->
        <div
            v-if="
                element.status === 1 &&
                !(element.isSnsCreating || element.isSnsRestoring)
            "
            class="d-flex flex-column align-items-center image-error"
        >
            <IconError />
            <span class="font-size-75 mt-2">Error</span>
        </div>
    </div>
</template>

<style>
.v-progress-linear__indeterminate {
    height: inherit !important;
}
</style>

<script>
import { BOOT_STEP_DESCRIPTION } from "@/constant/machine";

import IconExtend from "@/assets/svg/Extend";
import IconError from "@/assets/svg/Error";
import IconBoot from "@/assets/svg/Boot";
import IconShutdown from "@/assets/svg/Shutdown";
import IconSaving from "@/assets/svg/Saving";
import IconConnect from "@/assets/svg/Connect";
import IconProcessing from "@/assets/svg/Processing";
import IconTimer from "@/assets/svg/Timer";

export default {
    components: {
        IconExtend,
        IconError,
        IconBoot,
        IconShutdown,
        IconSaving,
        IconConnect,
        IconProcessing,
        IconTimer,
    },

    data() {
        return {
            packageRequiredFixedRental: ["24", "25", "30"],
            bootStepDescription: BOOT_STEP_DESCRIPTION,
        };
    },

    props: {
        element: {
            type: Object,
            default() {
                return {};
            },
        },
    },

    methods: {
        action(type) {
            this.$emit("processingEvent", {
                event: "action",
                data: {
                    type: type,
                    data: this.element,
                },
            });
        },
    },
};
</script>